export const BANK_MAP = {
  "970425": { name: "Ngân hàng An Bình (ABBANK)", logo: "https://cdn.vietqr.io/img/ABB.png" },
  "01323001": { name: "Ngân hàng An Bình (ABBANK)", logo: "https://cdn.vietqr.io/img/ABB.png" },
  "01323002": { name: "Ngân hàng An Bình (ABBANK)", logo: "https://cdn.vietqr.io/img/ABB.png" },
  "970416": { name: "Ngân hàng Á Châu (ACB)", logo: "https://cdn.vietqr.io/img/ACB.png" },
  "79307001": { name: "Ngân hàng Á Châu (ACB)", logo: "https://cdn.vietqr.io/img/ACB.png" },
  "970409": { name: "Ngân hàng Bắc Á (Bac A Bank)", logo: "https://cdn.vietqr.io/img/BAB.png" },
  "01313007": { name: "Ngân hàng Bắc Á (Bac A Bank)", logo: "https://cdn.vietqr.io/img/BAB.png" },
  "40313001": { name: "Ngân hàng Bắc Á (Bac A Bank)", logo: "https://cdn.vietqr.io/img/BAB.png" },
  "970418": { name: "Ngân hàng Đầu tư và Phát triển Việt Nam (BIDV)", logo: "https://cdn.vietqr.io/img/BIDV.png" },
  "01202001": { name: "Ngân hàng Đầu tư và Phát triển Việt Nam (BIDV)", logo: "https://cdn.vietqr.io/img/BIDV.png" },
  "970438": { name: "Ngân hàng Bảo Việt (BaoViet Bank)", logo: "https://cdn.vietqr.io/img/BVB.png" },
  "01359001": { name: "Ngân hàng Bảo Việt (BaoViet Bank)", logo: "https://cdn.vietqr.io/img/BVB.png" },
  "970444": { name: "Ngân hàng Xây dựng (CB)", logo: "https://cdn.vietqr.io/img/CBB.png" },
  "79339002": { name: "Ngân hàng Xây dựng (CB)", logo: "https://cdn.vietqr.io/img/CBB.png" },
  "970446": { name: "Ngân hàng Hợp tác xã Việt Nam (Co-op Bank)", logo: "https://cdn.vietqr.io/img/COOPBANK.png" },
  "422589": { name: "Ngân hàng CIMB Việt Nam", logo: "https://cdn.vietqr.io/img/CIMB.png" },
  "796500": { name: "Ngân hàng DBS - Chi nhánh HCM", logo: "https://cdn.vietqr.io/img/DBS.png" },
  "970406": { name: "Ngân hàng Đông Á (DongA Bank)", logo: "https://cdn.vietqr.io/img/Vikki.png" },
  "970431": { name: "Ngân hàng Xuất Nhập khẩu (Eximbank)", logo: "https://cdn.vietqr.io/img/EIB.png" },
  "79305001": { name: "Ngân hàng Xuất Nhập khẩu (Eximbank)", logo: "https://cdn.vietqr.io/img/EIB.png" },
  "970408": { name: "Ngân hàng Dầu khí Toàn cầu (GPBank)", logo: "https://cdn.vietqr.io/img/GPB.png" },
  "970437": { name: "Ngân hàng Phát triển TP.HCM (HDBank)", logo: "https://cdn.vietqr.io/img/HDB.png" },
  "970442": { name: "Ngân hàng Hong Leong Việt Nam", logo: "https://cdn.vietqr.io/img/HLBVN.png" },
  "458761": { name: "Ngân hàng HSBC Việt Nam", logo: "https://cdn.vietqr.io/img/HSBC.png" },
  "970455": { name: "Ngân hàng Công nghiệp Hàn Quốc - Hà Nội", logo: "https://cdn.vietqr.io/img/IBK.png" },
  "970456": { name: "Ngân hàng Công nghiệp Hàn Quốc - HCM", logo: "https://cdn.vietqr.io/img/IBK.png" },
  "970415": { name: "Ngân hàng Công Thương Việt Nam (VietinBank)", logo: "https://cdn.vietqr.io/img/ICB.png" },
  "01201001": { name: "Ngân hàng Công Thương Việt Nam (VietinBank)", logo: "https://cdn.vietqr.io/img/ICB.png" },
  "970434": { name: "Ngân hàng Indovina (IVB)", logo: "https://cdn.vietqr.io/img/IVB.png" },
  "970462": { name: "Ngân hàng Kookmin - Hà Nội", logo: "https://cdn.vietqr.io/img/KBHN.png" },
  "970463": { name: "Ngân hàng Kookmin - HCM", logo: "https://cdn.vietqr.io/img/KBHCM.png" },
  "970452": { name: "Ngân hàng Kiên Long (Kienlongbank)", logo: "https://cdn.vietqr.io/img/KLB.png" },
  "91353001": { name: "Ngân hàng Kiên Long (Kienlongbank)", logo: "https://cdn.vietqr.io/img/KLB.png" },
  "668888": { name: "Ngân hàng KBank Chi nhánh HCM", logo: "https://cdn.vietqr.io/img/KBANK.png" },
  "970449": { name: "Ngân hàng Bưu điện Liên Việt (LPBank)", logo: "https://cdn.vietqr.io/img/LPB.png" },
  "01357001": { name: "Ngân hàng Bưu điện Liên Việt (LPBank)", logo: "https://cdn.vietqr.io/img/LPB.png" },
  "970422": { name: "Ngân hàng Quân đội (MB)", logo: "https://cdn.vietqr.io/img/MB.png" },
  "97042292": { name: "Ngân hàng Quân đội (MB)", logo: "https://cdn.vietqr.io/img/MB.png" },
  "970426": { name: "Ngân hàng Hàng Hải (MSB)", logo: "https://cdn.vietqr.io/img/MSB.png" },
  "01302001": { name: "Ngân hàng Hàng Hải (MSB)", logo: "https://cdn.vietqr.io/img/MSB.png" },
  "970428": { name: "Ngân hàng Nam Á (Nam A Bank)", logo: "https://cdn.vietqr.io/img/NAB.png" },
  "970419": { name: "Ngân hàng Quốc Dân (NCB)", logo: "https://cdn.vietqr.io/img/NCB.png" },
  "801011": { name: "Ngân hàng Nonghyup - Hà Nội", logo: "https://cdn.vietqr.io/img/NHB.png" },
  "970448": { name: "Ngân hàng Phương Đông (OCB)", logo: "https://cdn.vietqr.io/img/OCB.png" },
  "79333001": { name: "Ngân hàng Phương Đông (OCB)", logo: "https://cdn.vietqr.io/img/OCB.png" },
  "970414": { name: "Ngân hàng Đại Dương (OceanBank)", logo: "https://cdn.vietqr.io/img/MBV.png" },
  "970439": { name: "Ngân hàng Public Bank Việt Nam", logo: "https://cdn.vietqr.io/img/PBVN.png" },
  "970430": { name: "Ngân hàng Xăng dầu Petrolimex (PG Bank)", logo: "https://cdn.vietqr.io/img/PGB.png" },
  "970412": { name: "Ngân hàng Đại Chúng (PVcomBank)", logo: "https://cdn.vietqr.io/img/PVCB.png" },
  "971133": { name: "Dịch vụ thanh toán PVcomBank", logo: "https://cdn.vietqr.io/img/PVCB.png" },
  "970429": { name: "Ngân hàng Sài Gòn (SCB)", logo: "https://cdn.vietqr.io/img/SCB.png" },
  "970410": { name: "Ngân hàng Standard Chartered Việt Nam", logo: "https://cdn.vietqr.io/img/SCVN.png" },
  "970440": { name: "Ngân hàng Đông Nam Á (SeABank)", logo: "https://cdn.vietqr.io/img/SEAB.png" },
  "01317001": { name: "Ngân hàng Đông Nam Á (SeABank)", logo: "https://cdn.vietqr.io/img/SEAB.png" },
  "970400": { name: "Ngân hàng Sài Gòn Công Thương (Saigonbank)", logo: "https://cdn.vietqr.io/img/SGICB.png" },
  "970443": { name: "Ngân hàng Sài Gòn - Hà Nội (SHB)", logo: "https://cdn.vietqr.io/img/SHB.png" },
  "01348002": { name: "Ngân hàng Sài Gòn - Hà Nội (SHB)", logo: "https://cdn.vietqr.io/img/SHB.png" },
  "970403": { name: "Ngân hàng Sài Gòn Thương Tín (Sacombank)", logo: "https://cdn.vietqr.io/img/STB.png" },
  "79303001": { name: "Ngân hàng Sài Gòn Thương Tín (Sacombank)", logo: "https://cdn.vietqr.io/img/STB.png" },
  "970424": { name: "Ngân hàng Shinhan Việt Nam", logo: "https://cdn.vietqr.io/img/SHBVN.png" },
  "970407": { name: "Ngân hàng Kỹ thương (Techcombank)", logo: "https://cdn.vietqr.io/img/TCB.png" },
  "01310001": { name: "Ngân hàng Kỹ thương (Techcombank)", logo: "https://cdn.vietqr.io/img/TCB.png" },
  "970423": { name: "Ngân hàng Tiên Phong (TPBank)", logo: "https://cdn.vietqr.io/img/TPB.png" },
  "01358001": { name: "Ngân hàng Tiên Phong (TPBank)", logo: "https://cdn.vietqr.io/img/TPB.png" },
  "970458": { name: "Ngân hàng UOB Việt Nam", logo: "https://cdn.vietqr.io/img/UOB.png" },
  "970427": { name: "Ngân hàng Việt Á (VietABank)", logo: "https://cdn.vietqr.io/img/VAB.png" },
  "970405": { name: "Ngân hàng Nông nghiệp & PTNT (Agribank)", logo: "https://cdn.vietqr.io/img/VBA.png" },
  "970499": { name: "Ngân hàng Nông nghiệp & PTNT (Agribank)", logo: "https://cdn.vietqr.io/img/VBA.png" },
  "01204001": { name: "Ngân hàng Nông nghiệp & PTNT (Agribank)", logo: "https://cdn.vietqr.io/img/VBA.png" },
  "970436": { name: "Ngân hàng Ngoại thương (Vietcombank)", logo: "https://cdn.vietqr.io/img/VCB.png" },
  "01203001": { name: "Ngân hàng Ngoại thương (Vietcombank)", logo: "https://cdn.vietqr.io/img/VCB.png" },
  "970454": { name: "Ngân hàng Bản Việt (Viet Capital Bank)", logo: "https://cdn.vietqr.io/img/VCCB.png" },
  "79327001": { name: "Ngân hàng Bản Việt (Viet Capital Bank)", logo: "https://cdn.vietqr.io/img/VCCB.png" },
  "970441": { name: "Ngân hàng Quốc tế (VIB)", logo: "https://cdn.vietqr.io/img/VIB.png" },
  "79314013": { name: "Ngân hàng Quốc tế (VIB)", logo: "https://cdn.vietqr.io/img/VIB.png" },
  "970433": { name: "Ngân hàng Việt Nam Thương Tín (Vietbank)", logo: "https://cdn.vietqr.io/img/VIETBANK.png" },
  "970432": { name: "Ngân hàng Việt Nam Thịnh Vượng (VPBank)", logo: "https://cdn.vietqr.io/img/VPB.png" },
  "01309001": { name: "Ngân hàng Việt Nam Thịnh Vượng (VPBank)", logo: "https://cdn.vietqr.io/img/VPB.png" },
  "546034": { name: "Ngân hàng Số CAKE", logo: "https://cdn.vietqr.io/img/CAKE.png" },
  "546035": { name: "Ngân hàng Số Ubank", logo: "https://cdn.vietqr.io/img/UBANK.png" },
  "970421": { name: "Ngân hàng Liên doanh Việt - Nga (VRB)", logo: "https://cdn.vietqr.io/img/VRB.png" },
  "970457": { name: "Ngân hàng Woori Việt Nam", logo: "https://cdn.vietqr.io/img/WVN.png" },
  "999888": { name: "Ngân hàng Chính sách xã hội (VBSP)", logo: "https://cdn.vietqr.io/img/VBSP.png" },
  "970467": { name: "Ngân hàng KEB Hana - Hà Nội", logo: "https://cdn.vietqr.io/img/KEBHANAHN.png" },
  "970466": { name: "Ngân hàng KEB Hana - HCM", logo: "https://cdn.vietqr.io/img/KEBHANAHCM.png" },
  "971011": { name: "Ví điện tử VNPT Money", logo: "https://cdn.vietqr.io/img/VNPTMONEY.png" },
  "971005": { name: "Ví điện tử Viettel Money", logo: "https://cdn.vietqr.io/img/VIETTELMONEY.png" },
  "963388": { name: "Ngân hàng số Timo", logo: "https://vietqr.net/portal-service/resources/icons/TIMO.png" },
  "977777": { name: "Tài chính Mirae Asset", logo: "https://cdn.vietqr.io/img/MAFC.png" },
  "533948": { name: "Ngân hàng Citibank Việt Nam", logo: "https://cdn.vietqr.io/img/CITIBANK.png" },
  "971025": { name: "Ví điện tử MoMo", logo: "https://cdn.vietqr.io/img/momo.png" },
  "963369": { name: "Ngân hàng số Liobank", logo: null },
  "971032": { name: "Ví điện tử Mobifone Money", logo: null },
  "555666": { name: "Ngân hàng BIDC", logo: null },
  "168999": { name: "Ngân hàng United Overseas Bank (UOB)", logo: null },
  "963688": { name: "Ngân hàng Bank of China", logo: null },
  "963666": { name: "Ngân hàng BNP Paribas HCM", logo: null },
  "963668": { name: "Ngân hàng BNP Paribas Hà Nội", logo: null },
  "963368": { name: "Tài chính Shinhan Việt Nam (SVFC)", logo: null },
  "963669": { name: "Ngân hàng ICBC - Hà Nội", logo: null },
};

export const SEGMENT_CONFIG = [
  { id: "micro", label: "Micro", range: "< 2 triệu", color: "bg-slate-400" },
  { id: "small", label: "Small", range: "2 - 5 triệu", color: "bg-blue-400" },
  {
    id: "medium",
    label: "Medium",
    range: "5 - 10 triệu",
    color: "bg-indigo-500",
  },
  { id: "large", label: "Large", range: "> 10 triệu", color: "bg-purple-600" },
];


export const RAW_MERCHANT_DATA = [
  {
    userName: "DO THI THIEP",
    userAddress: "TO 2 - PHUONG TRAN HUNG DAO - TINH HUNG YEN - VIET NAM",
    terminalID: "MBBMS0118430",
    merchantAddress: "Thai binh",
    businessRegistrationNumber: "HKD8617254633001",
    businessType: "Bán lẻ hàng hóa (tạp hóa, cửa hàng tiện lợi)",
    workspaceName: "Long linh",
  },
  {
    userName: "GIAP NGOC LUYEN",
    userAddress:
      "LE TRIEN-PHUONG DINH KE-THANH PHO BAC GIANG-TINH BAC GIANG-VIET NAM",
    terminalID: "MBBMS0124687",
    merchantAddress: "641a lê lợi dĩnh kế tp bắc giang",
    businessRegistrationNumber: "8475836626-001",
    businessType: "Dịch vụ y tế, chăm sóc sức khỏe",
    workspaceName: "Pk bác sĩ Luyến",
  },
  {
    userName: "KIENG THUY MO",
    userAddress:
      "KHOI 5-PHUONG HOANG VAN THU-THANH PHO LANG SON-TINH LANG SON-VIET NAM",
    terminalID: "MBBMS0131325",
    merchantAddress: "89 Nguyễn khắc cần",
    businessRegistrationNumber: "8616300358-002",
    businessType: "Dịch vụ y tế, chăm sóc sức khỏe",
    workspaceName: "SAM GARDEN",
  },
  {
    userName: "NGUYEN THANH QUYEN",
    userAddress:
      "KHU PHO 2-THI TRAN HUONG CANH-HUYEN BINH XUYEN-TINH VINH PHUC-VIET NAM",
    terminalID: "MBBMS0176762",
    merchantAddress: "Chợ Tân Long",
    businessRegistrationNumber: "8940172429-001",
    businessType: "Bán lẻ hàng hóa (tạp hóa, cửa hàng tiện lợi)",
    workspaceName: "Trà Bác Thái Nguyên",
  },
  {
    userName: "PHAM TIEN DUC",
    userAddress:
      "SUOI LON-XA DUONG TO-THANH PHO PHU QUOC-TINH KIEN GIANG-VIET NAM",
    terminalID: "MBBMS01891",
    merchantAddress: "Tổ 8, ấp suối lớn, xã dương tơ, phú quốc, kiên giang",
    businessRegistrationNumber: "HKD038077017157",
    businessType: "Bán buôn hàng hóa",
    workspaceName: "Đức Luận",
  },
  {
    userName: "LE VAN HUE",
    userAddress:
      "HUYEN KY TO 7-PHUONG PHU LAM-QUAN HA DONG-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS014901",
    merchantAddress: "Số 1 Ngô Thì Nhậm Quang Trung Hà Đông HN",
    businessRegistrationNumber: "8410899321001",
    businessType: "Bán buôn hàng hóa",
    workspaceName: "Cửa hàng  sửa khóa huế huyền",
  },
  {
    userName: "NGUYEN VAN TIEN",
    userAddress:
      "KHU LUNG THUONG-XA HA THACH-THI XA PHU THO-TINH PHU THO-VIET NAM",
    terminalID: "MBBMS01251576",
    merchantAddress: "KHU LUNG THUONG",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tien Tap Hoa",
  },
  {
    userName: "NGUYEN THI HUONG",
    userAddress: "THON 2-XA HOP TIEN-HUYEN TRIEU SON-TINH THANH HOA-VIET NAM",
    terminalID: "MBBMS012516",
    merchantAddress: "Mixue cho mun _kim chung _Dong Anh _Ha Noi",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Mixue Cho Mun",
  },
  {
    userName: "THAI NGOC HOA BINH",
    userAddress:
      "14 Nguyen Luong Bang    To Dan Pho 8  Tan Lap  Buon Ma Thuot  Dak Lak",
    terminalID: "MBBMS01251603",
    merchantAddress: "14 Nguyễn Lương Bằng",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Hoà Bình Minimart",
  },
  {
    userName: "NGUYEN THI HIEN",
    userAddress:
      "THON CHE DEN 2 - XA HOANG KHAI - HUYEN YEN SON - TINH TUYEN QUANG - VIET NAM",
    terminalID: "MBBMS01251606",
    merchantAddress: "Thôn Chè đen 2",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Nguyễn Thị Hiên",
  },
  {
    userName: "VI THI HIEN",
    userAddress:
      "THON 9-XA HAI XUAN-THANH PHO MONG CAI-TINH QUANG NINH-VIET NAM",
    terminalID: "MBBMS01251607",
    merchantAddress: "44 Bình Thuận Khu 9",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tạp hoá Vi Thị Hiên",
  },
  {
    userName: "VU THI BICH",
    userAddress: "TAN THE - XA NGOC THIEN - TINH BAC NINH - VIET NAM",
    terminalID: "MBBMS0125161",
    merchantAddress: "Kí túc xá b4 đại học nông nghiệp trâu quỳ gia lâm hà nội",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Canteen KTX B4",
  },
  {
    userName: "PHI HAU GIANG",
    userAddress: "TO DAN PHO 5  NGHIA TRUNG  TP GIA NGHIA  DAK NONG",
    terminalID: "MBBMS01251610",
    merchantAddress: "34 trương định",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Thảo hiền từ",
  },
  {
    userName: "DO VAN QUANG",
    userAddress: "TAN NAM-XA MY DUC-HUYEN AN LAO-TP HAI PHONG-VIET NAM",
    terminalID: "MBBMS01251623",
    merchantAddress: "hải phòng",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "cafe 1995",
  },
  {
    userName: "NGUYEN THI THINH",
    userAddress: "NHAN LE-XA DANG XA-HUYEN GIA LAM-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251624",
    merchantAddress: "TT xã phú thị",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Đồ lính",
  },
  {
    userName: "HOANG THI HONG PHUC",
    userAddress:
      "TDP TIEN PHONG-PHUONG MAI HUNG-THI XA HOANG MAI-TINH NGHE AN-VIET NAM",
    terminalID: "MBBMS01251627",
    merchantAddress: "tổ dân phố yên phú chợ mai hùng",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Hồng Phúc",
  },
  {
    userName: "LE THUY DUNG",
    userAddress:
      "THON YEN BE-XA KIM CHUNG-HUYEN HOAI DUC-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251630",
    merchantAddress: "Xóm Đình thôn Yên Bệ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Cửa hàng Dũng",
  },
  {
    userName: "NGUYEN DAC TIEN",
    userAddress:
      "CAO BAT DINH-XA NAM CAO-HUYEN KIEN XUONG-TINH THAI BINH-VIET NAM",
    terminalID: "MBBMS01251632",
    merchantAddress: "Cao Bạt Đình",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Goc Nho Coffee and Tea",
  },
  {
    userName: "PHAM VAN HACH",
    userAddress: "THON MY XA-XA VIET CUONG-HUYEN YEN MY-TINH HUNG YEN-VIET NAM",
    terminalID: "MBBMS01251633",
    merchantAddress: "Thôn Mỹ Xá",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tạo Hoá Khích Hách",
  },
  {
    userName: "VO MINH THIEN",
    userAddress:
      "A5/153/2 AP 1-XA DA PHUOC-HUYEN BINH CHANH-TP HO CHI MINH-VIET NAM",
    terminalID: "MBBMS01251637",
    merchantAddress: "172B Lê Thị Hà ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "MALATANG HOTPOT MỲ CAY TỨ XUYÊN",
  },
  {
    userName: "LUC THI CHIEU",
    userAddress:
      "THON THANH DIEN-XA DIEN HA-HUYEN BA THUOC-TINH THANH HOA-VIET NAM",
    terminalID: "MBBMS01251640",
    merchantAddress: "Khu Rừng Luồng",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tạp Hoá Đại Long",
  },
  {
    userName: "NGUYEN THI YEN",
    userAddress:
      "TO 15-PHUONG PHUC DIEN-QUAN BAC TU LIEM-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251642",
    merchantAddress: "Ngã 3 Văn Tiến Dũng",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Cửa hàng Anh Đức",
  },
  {
    userName: "NGUYEN THI THANH",
    userAddress: "To Dan Pho Trung 7  Tay Tuu  Bac Tu Liem  Ha Noi",
    terminalID: "MBBMS01251645",
    merchantAddress: "Số 27ngõ 164 trung kiên tây tựu",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Số 27ngõ 164 trung kiên tây tưu",
  },
  {
    userName: "TRAN THANH TUNG",
    userAddress: "HUNG YEN-XA LAC DAO-HUYEN VAN LAM-TINH HUNG YEN-VIET NAM",
    terminalID: "MBBMS01251649",
    merchantAddress: "64 Nguyễn Thiện Thuật",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Lilak Phố Nối",
  },
  {
    userName: "PHAM THI DUC",
    userAddress:
      "THON THO AM-XA LIEN NINH-HUYEN THANH TRI-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251650",
    merchantAddress: "Số nhà 71 đường đình",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tâm Đức",
  },
  {
    userName: "NGUYEN THI LIEN",
    userAddress:
      "DON LUONG-PHUONG YEN BAC-THI XA DUY TIEN-TINH HA NAM-VIET NAM",
    terminalID: "MBBMS01251652",
    merchantAddress: "Đô lương  yên Bắc duy tiên hà nam",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Bán hoa quả",
  },
  {
    userName: "NGUYEN QUE CHUYEN",
    userAddress:
      "XOM GIENG THON 6-XA CONG HOA-HUYEN QUOC OAI-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251653",
    merchantAddress: "Xóm Giếng Thôn 6 Xã Cộng Hoà Huyện Quốc Oai Hà Nội",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Minh Ngọc Quán",
  },
  {
    userName: "HA HONG PHUC",
    userAddress: "Ap Tra Ban 2  Chau Hung A  Vinh Loi  Bac Lieu",
    terminalID: "MBBMS01251655",
    merchantAddress: "8 kdc bến lức p7 q8 Tphcm",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Hà Phúc",
  },
  {
    userName: "NGUYEN THI O",
    userAddress:
      "NGUYEN HUY BINH-PHUONG XUONG GIANG-THANH PHO BAC GIANG-TINH BAC GIANG-VIET NAM",
    terminalID: "MBBMS01251656",
    merchantAddress: "SN 56 Nguyễn Hữu Bính",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Nguyễn Thị Ô",
  },
  {
    userName: "NGUYEN THI THAO NHI",
    userAddress:
      "THON KIEU CHAU-XA DUY SON-HUYEN DUY XUYEN-TINH QUANG NAM-VIET NAM",
    terminalID: "MBBMS01251658",
    merchantAddress: "Thôn kiệu châu ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tiệm bánh Nami ",
  },
  {
    userName: "NGUYEN THI AN",
    userAddress:
      "19/107 khu pho Hoa Lan 2 Phuong Thuan Giao  Thanh pho Ho Chi Minh  VIET NAM",
    terminalID: "MBBMS01251660",
    merchantAddress:
      "19107 khu hòa hòa lân hai thuận giao thuận an bình dương ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Tạp hóa Việt Anh Phát ",
  },
  {
    userName: "DAO THI THANH THUY",
    userAddress:
      "THON TRUONG XA-XA TOAN THANG-HUYEN KIM DONG-TINH HUNG YEN-VIET NAM",
    terminalID: "MBBMS01251662",
    merchantAddress: "Trương xá ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Thủy Trượng ",
  },
  {
    userName: "TRAN THI LIEU",
    userAddress:
      "BUON TAR-PHUONG CAT LINH-QUAN DONG DA-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251663",
    merchantAddress: "Thôn 5",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Vịt quay Lộc Phát",
  },
  {
    userName: "PHAN MI MI",
    userAddress:
      "GO HA-XA HOA KHUONG-HUYEN HOA VANG-THANH PHO DA NANG-VIET NAM",
    terminalID: "MBBMS01251664",
    merchantAddress: "Thôn phú hoà 2 ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "HKD BKR đồng tiến hoà nhơn ",
  },
  {
    userName: "PHUNG THI THOM",
    userAddress:
      "THON DONG LAU-XA PHU DONG-HUYEN BA VI-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251667",
    merchantAddress: "Đối diện ngã 3 chợ Học Viện cảnh sát nhân dân",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Đồ ăn vặt K1",
  },
  {
    userName: "LE THI LOI",
    userAddress: "Thon 5  Ea Bhok  Cu Kuin  Dak Lak",
    terminalID: "MBBMS01251673",
    merchantAddress: "Thôn 5",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Dũng Lợi",
  },
  {
    userName: "NGUYEN ANH TUAN",
    userAddress:
      "TDP PHO HUYEN-THI TRAN QUOC OAI-HUYEN QUOC OAI-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251675",
    merchantAddress: "A27 dg 06 Thôn Phủ Quốc",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "86 Cyber Game",
  },
  {
    userName: "NGUYEN THI HOA",
    userAddress:
      "KHU DA DEN-XA THANG SON-HUYEN THANH SON-TINH PHU THO-VIET NAM",
    terminalID: "MBBMS01251679",
    merchantAddress: "Khu 10 đồng trung",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Hoa Cf mộc",
  },
  {
    userName: "DO THI HIEN",
    userAddress:
      "SO 60 32 33 NHI DONG 2-PHUONG DI AN-THANH PHO DI AN-TINH BINH DUONG-VIET NAM",
    terminalID: "MBBMS0125168",
    merchantAddress: "Đường Võ Thị Sáu Thái Hoà Tân Uyên Bình Dương",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Siêu thị sữa Donal Kids",
  },
  {
    userName: "DAO THI NGAN",
    userAddress: "Doi 8  Ta Thanh Oai  Thanh Tri  Ha Noi",
    terminalID: "MBBMS01251682",
    merchantAddress: "15a Ngõ 214 Nguyễn Xiển",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Bánh cuốn cô Ngân",
  },
  {
    userName: "PHAM KIM HOA",
    userAddress:
      "TO 11B-PHUONG HOANG LIET-QUAN HOANG MAI-THANH PHO HA NOI-VIET NAM",
    terminalID: "MBBMS01251690",
    merchantAddress: "Số 4 tổ 4 thị trấn văn điển",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Hoa Bún",
  },
  {
    userName: "LE THI SANG",
    userAddress: "Thon Thai Nhan Xa Tan Ninh  Tinh Thanh Hoa  VIET NAM",
    terminalID: "MBBMS01251692",
    merchantAddress: "Cổng Trường Mầm Non Thái Hoà",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Nhà Hàng Du Sáng",
  },
  {
    userName: "NGUYEN VAN SU",
    userAddress:
      "THON NGA LONG-XA NGUYEN LY-HUYEN LY NHAN-TINH HA NAM-VIET NAM",
    terminalID: "MBBMS01251694",
    merchantAddress: "87 Nguyễn phúc lai",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "87 Nguyễn Phúc Lai",
  },
  {
    userName: "NGUYEN THANH TAM",
    userAddress: "285 KP4-PHUONG 9-THANH PHO MY THO-TINH TIEN GIANG-VIET NAM",
    terminalID: "MBBMS01251695",
    merchantAddress: "285 khu phố 4 Quốc Lộ 50",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Cà phê Phượng Nguyên 2",
  },
  {
    userName: "HO THI THANH PHUONG",
    userAddress:
      "5 NGUYEN CUU DAM-PHUONG TAN SON NHI-QUAN TAN PHU-TP HO CHI MINH-VIET NAM",
    terminalID: "MBBMS01100096",
    merchantAddress: "B002CN6ChungcuSonKy",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Mộc Chill Coffee",
  },
  {
    userName: "TRAN THI KIM THOA",
    userAddress:
      "71A DO DOC LONG-PHUONG TAN QUY-QUAN TAN PHU-TP HO CHI MINH-VIET NAM",
    terminalID: "MBBMS01100089",
    merchantAddress: "92 duong 1",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Nuoc ep 92",
  },
  {
    userName: "NGUYEN PHI PHUONG",
    userAddress:
      "16D NGUYEN BA LUAT-PHUONG BINH THO-THANH PHO THU DUC-TP HO CHI MINH-VIET NAM",
    terminalID: "MBBMS01100117",
    merchantAddress: "14 Nguyen Ba Luat",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Phương Minh",
  },
  {
    userName: "BUI VAN HUY",
    userAddress: "XUAN HONG-XA GIAO HA-HUYEN GIAO THUY-TINH NAM DINH-VIET NAM",
    terminalID: "MBBMS01100129",
    merchantAddress: "Khu phố Ninh Tịnh 6 ",
    businessRegistrationNumber: null,
    businessType: null,
    workspaceName: "Gia dụng Nhật Huy",
  },
];
